export default __webpack_public_path__ + "static/media/img-step2.789be93b.png";